import React, { memo } from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  EmailField,
  DateField,
  useRecordContext,
} from 'react-admin';
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import ImgField from '../../../components/ImgField/ImgField';

const styles = {
  showLayout: {
    paddingTop: '0px !important',
    paddingBottom: '0px',
  },
};

const ShowGridWrapper = () => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  return (
    <Grid container spacing={1}>
      <Grid size={{ md: 3 }} style={{ textAlign: 'center' }}>
        <ImgField
          record={record}
          source="picture"
          title="Picture"
          addLabel
          width="270"
          height="270"
        />
      </Grid>
      <Grid size={{ md: 9 }}>
        <SimpleShowLayout>
          <TextField source="firstName" label="First Name" />
          <TextField source="lastName" label="Last Name" />
          <EmailField source="email" />
          <TextField source="role" />
          <DateField source="createdAt" label="Date Created" />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};

const ShowAdmin = ({ classes, ...props }) => {
  return (
    <Show {...props} actions={null}>
      <SimpleShowLayout className={classes.showLayout}>
        <ShowGridWrapper />
      </SimpleShowLayout>
    </Show>
  );
};

export default memo(withStyles(styles)(ShowAdmin));
